import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect } from "react";
const MetaballBlob = ({ level, size }) => {
  const t = useRef(0);
  const [circles, setCircles] = useState([]);
  useEffect(() => {
    let raf;
    const N = 5;
    const tick = () => {
      t.current += 0.015;
      const c = [];
      for (let i = 0; i < N; i++) {
        const a = i / N * Math.PI * 2 + t.current * 0.4;
        const r = 12 + level * 14;
        const dist = 14 + Math.sin(t.current * 1.2 + i) * 6 + level * 12;
        c.push({
          cx: 50 + Math.cos(a) * dist,
          cy: 50 + Math.sin(a) * dist,
          r
        });
      }
      c.push({ cx: 50, cy: 50, r: 18 + level * 8 });
      setCircles(c);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [level]);
  return /* @__PURE__ */ jsxs("svg", { width: size, height: size, viewBox: "0 0 100 100", "aria-hidden": true, children: [
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("filter", { id: "voice-meta-goo", children: [
        /* @__PURE__ */ jsx("feGaussianBlur", { in: "SourceGraphic", stdDeviation: "2.2", result: "blur" }),
        /* @__PURE__ */ jsx("feColorMatrix", { in: "blur", mode: "matrix", values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: "voice-meta-g", x1: "0", y1: "0", x2: "1", y2: "1", children: [
        /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "#ffae00" }),
        /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "#ff2d75" })
      ] })
    ] }),
    /* @__PURE__ */ jsx("g", { filter: "url(#voice-meta-goo)", children: circles.map((c, i) => /* @__PURE__ */ jsx("circle", { cx: c.cx, cy: c.cy, r: c.r, fill: "url(#voice-meta-g)" }, i)) })
  ] });
};
export {
  MetaballBlob
};
//# sourceMappingURL=MetaballBlob.js.map
